import React from 'react';

// Small on/off switch with a sliding knob. Controlled: pass `checked` and `onChange(nextBool)`.
const ToggleSwitch = ({ checked, onChange, disabled = false, label }) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    aria-label={label}
    disabled={disabled}
    onClick={() => onChange(!checked)}
    style={{
      ...s.track,
      background: checked ? 'linear-gradient(135deg, var(--accent), var(--accent2))' : 'var(--border)',
      opacity: disabled ? 0.6 : 1,
      cursor: disabled ? 'default' : 'pointer',
    }}
  >
    <span style={{ ...s.knob, transform: checked ? 'translateX(20px)' : 'translateX(0)' }} />
  </button>
);

const s = {
  track: { position: 'relative', width: 44, height: 24, flexShrink: 0, borderRadius: 24, border: 'none', padding: 0, transition: 'background 0.25s ease, opacity 0.2s ease' },
  knob: { position: 'absolute', top: 2, left: 2, width: 20, height: 20, borderRadius: '50%', background: '#fff', boxShadow: '0 1px 3px rgba(0,0,0,0.35)', transition: 'transform 0.25s cubic-bezier(0.4, 0, 0.2, 1)' },
};

export default ToggleSwitch;
